export default "__VITE_ASSET__0b432937__"